import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import { AuthContext } from "../../components/AuthContext";
import axios from "axios";
import "./EventPage.css";
import { BASE_URL } from "../../config/baseUrl";

function EventPage() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/Event`)
      .then((res) => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then((data) => {
        const now = new Date();
        const upcoming = data
          .filter(ev => new Date(`${ev.startDate.split("T")[0]}T${ev.startTime}`) >= now)
          .sort((a, b) => new Date(`${a.startDate.split("T")[0]}T${a.startTime}`) - new Date(`${b.startDate.split("T")[0]}T${b.startTime}`));
        const past = data
          .filter(ev => new Date(`${ev.startDate.split("T")[0]}T${ev.startTime}`) < now)
          .sort((a, b) => new Date(`${b.startDate.split("T")[0]}T${b.startTime}`) - new Date(`${a.startDate.split("T")[0]}T${a.startTime}`));
        setEvents([...upcoming, ...past]);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching events:", err);
        setLoading(false);
      });
  }, []);

  const formatDateTime = (startDate, startTime) => {
    if (!startDate || !startTime) return "Date not available";
    const dt = new Date(`${startDate.split("T")[0]}T${startTime}`);
    if (isNaN(dt)) return "Date not available";
    return dt.toLocaleString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  };

  const isUpcoming = (startDate, startTime) => {
    const dt = new Date(`${startDate.split("T")[0]}T${startTime}`);
    return !isNaN(dt) && dt >= new Date();
  };

  const handleRegisterClick = async (event) => {
    if (!user) {
      navigate("/login");
      return;
    }

    try {
      const enrollData = {
        UserId: user.userId,
        FullName: user.fullName,
        Email: user.email,
        CatalogTypeName: "Event",
        CatalogItem: event.eventName
      };

      await axios.post(`${BASE_URL}/EnrollUser`, enrollData);

      alert(`You have successfully registered for "${event.eventName}"! Check your email for confirmation.`);
    } catch (err) {
      console.error(err);
      alert("Error registering for event. Please try again.");
    }
  };

  return (
    <>
      <Navbar />
      <section className="event-hero d-flex align-items-center">
        <div className="container text-center">
          <h1 className="crimson-text">🎉 Upcoming & Past Events</h1>
          <p>Join our events and be part of something great!</p>
        </div>
      </section>

      <main className="main events-page">
        <div className="container">
          {loading ? (
            <p className="loading-text">Loading events...</p>
          ) : (
            <>
              {events.length === 0 ? (
                <p className="empty-text">No events available at the moment.</p>
              ) : (
                <div className="row">
                  {events.map((ev) => (
                    <div key={ev.eventId} className="col-lg-4 col-md-6 mb-4">
                      <div className="event-card h-100">
                        <div className="event-img-wrapper position-relative">
                          <img
                            src={ev.coverImage || "https://via.placeholder.com/400x200"}
                            alt={ev.eventName}
                            className="img-fluid rounded"
                          />
                          <span className="badge crimson-bg event-type">{ev.source}</span>
                        </div>

                        <div className="p-3">
                          <h4 className="crimson-text mb-2">{ev.eventName}</h4>
                          <p className="small mb-1"><strong>📅 Date & Time:</strong> {formatDateTime(ev.startDate, ev.startTime)}</p>
                          <p className="small mb-1"><strong>📍 Location:</strong> {ev.location}</p>
                          <p className="small mb-1"><strong>🔖 Source:</strong> {ev.source}</p>
                          <p className="mb-2">{ev.description}</p>
                          <p className="small mb-3">{ev.isPaid ? `💰 Price: ₹${ev.price}` : "✅ Free Event"}</p>

                          {isUpcoming(ev.startDate, ev.startTime) ? (
                            <button onClick={() => handleRegisterClick(ev)} className="btn btn-register-small">
                              Register
                            </button>
                          ) : ev.link ? (
                            <a href={ev.link} target="_blank" rel="noopener noreferrer" className="btn btn-register-small btn-sm">
                              ▶ View Details
                            </a>
                          ) : (
                            <button className="btn btn-disabled btn-sm" disabled>No link available</button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}

export default EventPage;
